export default "__VITE_ASSET__BIOPdA7i__"